import { Stack } from 'braid-design-system';
import { memo } from 'react';
import reactHtmlParser from 'react-html-parser';

import { transformToBraid } from '../../../utils/htmlParser/transformToBraid';

interface Props {
  html: string;
}

/**
 * Transforms a html string to Braid wrapped output.
 * Memoizing the component so we don't have to recompute unless the html changes.
 */
export const HtmlParser = memo(({ html }: Props) => {
  // Replace all non-breaking spaces and tabs with normal spaces
  const htmlWithNormalSpaces = html.replaceAll(/[^\S\r\n]/g, ' ');
  const parsedHtml = reactHtmlParser(htmlWithNormalSpaces, {
    transform: transformToBraid,
  });

  return <Stack space="large">{parsedHtml}</Stack>;
});
